import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

// Page d'accès Équipe thérapeutique (parent2 supprimé)
export default function AccesEtendu({ role }) {
  const navigate = useNavigate()
  const [code, setCode] = useState('')
  const [erreur, setErreur] = useState('')
  const [loading, setLoading] = useState(false)

  const sessionKey = 'therapeute'
  const destination = '/therapeute'
  const titre = 'Accès Équipe thérapeutique'
  const desc = 'Entrez le code fourni par la famille'
  const color = '#0369a1'
  const isParent2 = false

  const valider = async (e) => {
    e.preventDefault()
    if (!code.trim()) return
    setLoading(true); setErreur('')
    const codeNorm = code.trim().toUpperCase()
    // RPC SECURITY DEFINER : validation côté serveur
    const { data, error } = await supabase
      .rpc('therapeute_get_enfant', { p_code: codeNorm })
    if (error || !data || data.length === 0) {
      setErreur('Code invalide. Vérifiez le code et réessayez.')
      setLoading(false); return
    }
    const enfant = data[0]
    sessionStorage.setItem(`${sessionKey}_enfant_id`, enfant.id)
    sessionStorage.setItem(`${sessionKey}_pseudonyme`, enfant.pseudonyme)
    sessionStorage.setItem(`${sessionKey}_code`, codeNorm)
    navigate(`${destination}/${enfant.id}`)
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: "'Inter', sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 380, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: '1px solid #e2e8f0' }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: `${color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {isParent2
              ? <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>
              : <><path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
              </>
            }
          </svg>
        </div>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>{titre}</h1>
        <p style={{ fontSize: 13, color: '#64748b', marginBottom: 24 }}>{desc}</p>
        <form onSubmit={valider}>
          <input
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase())}
            placeholder="Code d'accès (ex: AB12CD)"
            maxLength={6}
            style={{ width: '100%', padding: '12px 16px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: 18, fontWeight: 700, letterSpacing: 4, textAlign: 'center', fontFamily: "'Inter', sans-serif", outline: 'none', marginBottom: 8, boxSizing: 'border-box' }}
            onFocus={e => e.target.style.borderColor = color}
            onBlur={e => e.target.style.borderColor = '#e2e8f0'}
            autoFocus
          />
          {erreur && <p style={{ color: '#dc2626', fontSize: 13, marginBottom: 12 }}>{erreur}</p>}
          <button type="submit" disabled={loading || code.length < 6} style={{ width: '100%', padding: '12px', borderRadius: 10, border: 'none', background: code.length >= 6 ? color : '#e2e8f0', color: code.length >= 6 ? '#fff' : '#94a3b8', fontWeight: 700, fontSize: 15, cursor: code.length >= 6 ? 'pointer' : 'default', fontFamily: "'Inter', sans-serif" }}>
            {loading ? 'Vérification...' : 'Accéder'}
          </button>
        </form>
        <button onClick={() => navigate('/')} style={{ width: '100%', marginTop: 12, padding: '8px', background: 'none', border: 'none', color: '#94a3b8', fontSize: 12, cursor: 'pointer', fontFamily: "'Inter', sans-serif" }}>
          Retour à l'accueil
        </button>
      </div>
    </div>
  )
}
